/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserProfileDto,
    UserProfileDtoFromJSON,
    UserProfileDtoFromJSONTyped,
    UserProfileDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserProfileDtoPaginatedResultDto
 */
export interface UserProfileDtoPaginatedResultDto {
    /**
     * 
     * @type {number}
     * @memberof UserProfileDtoPaginatedResultDto
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDtoPaginatedResultDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDtoPaginatedResultDto
     */
    total?: number;
    /**
     * 
     * @type {Array<UserProfileDto>}
     * @memberof UserProfileDtoPaginatedResultDto
     */
    results?: Array<UserProfileDto> | null;
}

export function UserProfileDtoPaginatedResultDtoFromJSON(json: any): UserProfileDtoPaginatedResultDto {
    return UserProfileDtoPaginatedResultDtoFromJSONTyped(json, false);
}

export function UserProfileDtoPaginatedResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfileDtoPaginatedResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'take': !exists(json, 'take') ? undefined : json['take'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(UserProfileDtoFromJSON)),
    };
}

export function UserProfileDtoPaginatedResultDtoToJSON(value?: UserProfileDtoPaginatedResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'take': value.take,
        'page': value.page,
        'total': value.total,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(UserProfileDtoToJSON)),
    };
}


